import * as React from 'react';
import { get } from 'lodash';
import { useStores } from 'src/utils/useStore';
import { ModuleProps, SearchWizardProps } from 'src/utils/module-util';
import { checkValue } from 'src/components/common/helper';
import { VrboHotelWidgetComponent } from 'src/components/common/SearchWizard/shareduiwizard/Lodging/vrbo/code-split/hotelWidget-component';
import { FBSearchWizardComponent } from 'src/components/common/SearchWizard/code-split/search-component';
import { StopoverSearchComponent } from 'src/components/common/SearchWizard/code-split/stopoversearch-component';
import { AdvancedBookingDispatchContext } from '../modules/v2/v2-booking-widget/components/search-context';

const SearchWizard = (props: SearchWizardProps) => {
  const {
    context: { site },
  } = useStores();
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData, conciergePageData },
  } = useStores();

  const wizardLocalizationData = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData
    : checkValue(spotlightPageData)
      ? spotlightPageData
      : checkValue(conciergePageData)
        ? conciergePageData
        : {};

  const { data } = props;

  // VRBO only support hotel tab
  if (site?.brand === 'vrbo') {
    let wizardTabs =
      checkValue(get(data, 'wizardTabs', [])) && get(data, 'wizardTabs', []).length > 0
        ? get(data, 'wizardTabs', [])
        : [];

    wizardTabs = wizardTabs?.filter((tab: string) => tab?.toLowerCase() === 'hotel');
    if (wizardTabs?.length > 0) {
      return (
        <VrboHotelWidgetComponent
          {...props}
          wizardLocalization={get(wizardLocalizationData, 'wizardLocalization', {})}
          mccidData={{
            ...props.mccidData,
          }}
        />
      );
    } else {
      return null;
    }
  } else {

    const [selectedTab, setSelectedTab]: [string, React.Dispatch<React.SetStateAction<string>>] = React.useState('Hotel');
    const [searchFilters, setSearchFilters]: [any, React.Dispatch<React.SetStateAction<any>>] = React.useState({});
    
    if (checkValue(props?.isAdvanced) && props?.isAdvanced === true) {
      const dispatch = React.useContext(AdvancedBookingDispatchContext);
      React.useEffect(() => {
        dispatch({
          type: 'updateTab',
          activeTab: selectedTab,
        });
      }, [selectedTab]);

      React.useEffect(() => {
        dispatch({
          type: 'updateFilters',
          data: { ...searchFilters},
        });
      }, [searchFilters]);
    }

    return (
      <FBSearchWizardComponent
        {...props}
        wizardLocalization={get(wizardLocalizationData, 'wizardLocalization', {})}
        mccidData={{
          ...props.mccidData,
        }}
        isAdvanced={props?.isAdvanced}
        setActiveTab={setSelectedTab}
        setSearchFilters={setSearchFilters}
      />
    );
  }
};

const StopOverSearchWizard = (props: ModuleProps) => {
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData, conciergePageData },
  } = useStores();

  const wizardLocalizationData = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData
    : checkValue(spotlightPageData)
      ? spotlightPageData
      : checkValue(conciergePageData)
        ? conciergePageData
        : {};

  return (
    <StopoverSearchComponent
      {...props}
      wizardLocalization={get(wizardLocalizationData, 'wizardLocalization', {})}
      mccidData={{
        ...props.mccidData,
      }}
    />
  );
};

export { SearchWizard, StopOverSearchWizard };
